import React, { Component } from "react";
import Appbar from "./Appbar";
import {
  Box,
  Container,
  Divider,
  Grid2,
  Paper,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import ReactImageMagnify from "react-image-magnify";
import base_url from '.././src/base_url'

import bg2 from './bachround_img/bg.jpg'
import bg from './bachround_img/bg2.jpg'
import bg3 from './bachround_img/bg3.jpg'
import bg4 from './bachround_img/bg4.jpg'
import bg5 from './bachround_img/bg5.png'

import product1 from './product_img/product1.png'


export class ItemDescriptions extends Component {
constructor(props) {
  super(props)

  this.state = {
    productDetails : {},
    productImage : [],
    thumb_nail_img : "",




    ///// related productList here
    relatedProductList : [],
     
  }
}




componentDidMount(){
  let id = this.props.param.id.replace(/:/g,'')
 
   //// retrive single product details :-
   fetch(`${base_url.base_url}/product/retriveSingleProductById`, {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body:JSON.stringify({
      id : id
    })
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
     

      this.setState({
        productDetails : result.items, productImage:result.items.productImage, thumb_nail_img : result.items.thumb_nail_img
      })
    });


    //// retrive productList
    this.retriveRelatedProductList();
}




retriveRelatedProductList=()=>{
  fetch(`${base_url.base_url}/product/retriveRelatedProductList`, {
    headers: {
      "content-type": "application/json",
    },
    method: "get",
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      this.setState({
        relatedProductList : result.items
      })
    });
}




addItemInCartList = async (product_id) => {
  let email = await localStorage.getItem("email");
  if (product_id !== "" && email !== null) {
    fetch(`${base_url.base_url}/cartList/addItemsInCart`, {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        email: email,
        product_id: product_id,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        if (result.status) {
          this.Sucessfull();
        } else {
          this.Fail();
        }
      });
  } else {
    alert("Required Login");
  }
};


addItemInWishList = async (product_id) => {
  let email = await localStorage.getItem("email");
  if (product_id !== "" && email !== null) {
    fetch(`${base_url.base_url}/wishList/addItemsInWish`, {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        email: email,
        product_id: product_id,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        if (result.status) {
          this.Sucessfull();
        } else {
         this.removeFromWish();
        }
      });
  } else {
    alert("Required Login");
  }
};


  Sucessfull = () => {
    toast.success("Item added ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      // transition: Bounce,
    });
  };

  Fail = () => {
    toast.error("Item already exists ", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      //transition: Bounce,
    });
  };

    removeFromWish = () => {
      toast.success("Removed from wishList ", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        // transition: Bounce,
      });
    };
  

  render() {
    const tt = base_url.base +'/'+ this.state.thumb_nail_img;
    return (
      <div>
        <Box sx={{ pt: 4,
              backgroundImage: `url(${bg2})`,
                           backgroundSize: 'cover',
                           backgroundRepeat: 'no-repeat',
                           backgroundPosition: 'center',
                           minHeight: 1000, // Mandatory for visibility if content is empty
                           width: '100%'


         }}>
          <br />
          <br />
          <Container maxWidth="xl">
            <Box>
              <Grid2 container spacing={2}>

                <Grid2 item size={{ xs: 12, sm: 12,md:1 }}>
                  <Grid2 container spacing={1}>
                    
                    {
                     this.state.productImage.map((r)=>(
                         <Grid2 item size={{ xs: 3, sm: 3, md: 12 }}>
                      <Paper
                        elevation={2}
                        sx={{ height: 90, width: "100%",borderRadius:0}}
                        onClick={()=>this.setState({thumb_nail_img : r.img_url})}
                      >
                        <img  src={`${base_url.base}`+'/'+ `${r.img_url}`}   style={{height:90,width:'100%',objectFit:'cover',borderRadius:1}}/>
                      </Paper>
                    </Grid2> 
                     )) 
                 
                    }



                  </Grid2>
                </Grid2>

                <Grid2 item size={{ xs: 12, sm: 12,md:4}}>
                  <Box sx={{ minHeight: 200, width: "100%" }}>
                    <ReactImageMagnify
                      {...{
                        smallImage: {
                          alt: "jewellery",
                           isFluidWidth: true,
                          src: tt,
                        },
                        largeImage: { 
                          src: tt,
                          width:1200,
                          height:1200, 
                        },
                      }}
                    />
                  </Box>
                </Grid2>

                <Grid2 item size={{ xs: 12, sm: 12,md:7 }}>
                  <Box
                    sx={{
                      minHeight: 300,
                      width: "100%",
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <Typography
                      sx={{ fontSize: {xs:21,sm:21,md:26}, fontWeight: "500", pt: -2, mb: 0.5 ,color:'#1d294f'}}
                    >
                      {this.state.productDetails.product_name}
                    </Typography>
<Box sx={{height:2,width:'100%',backgroundColor:'#ab266c',mt:1,mb:1}}>

</Box>
                    <Typography
                      sx={{
                        fontSize: 14,
                        mt: 1,
                        fontWeight: "500",
                        textAlign: "justify",
                        color: "#4c4c4c",
                       // fontFamily:'san-serif'
                      }}
                    >
                   {this.state.productDetails.product_description}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                        alignItems: "center",
                        mt: 2,
                        mb:1
                      }}
                    >
                      <Typography sx={{ fontSize: 17, fontWeight: 600 }}>
                        Price
                      </Typography>
                      <Typography sx={{ fontSize: 20, fontWeight: 600, ml: 1 }}>
                      {(parseInt(this.state.productDetails.price)).toLocaleString('en-US', {
                                   style: 'currency',
                                   currency: 'INR',
                                    })}
                      </Typography>
                      
                      
                    </Box>
                     <Typography sx={{ fontSize: 17, fontWeight: 600}}>
                        Quantity : {this.state.productDetails.weight}
                      </Typography>

                    <Box
                      sx={{
                        height: 25,
                        width: 100,
                        backgroundColor: "#fe9f43",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 1,
                      }}
                    >
                      <Typography
                        sx={{ fontSize: 14, fontWeight: "600", color: "#fff" }}
                      >
                        30% off
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        mt: 2,
                        mb: 2,
                      }}
                    >
                      <Box onClick={this.addItemInCartList.bind(this,this.state.productDetails.product_id)}
                        sx={{
                          height: 35,
                          width: 100,
                          backgroundColor: "green",
                          display:'flex',
                          justifyContent:'center',
                          alignItems:'center',
                          borderRadius:1,
                        }}
                      >
                        <Typography sx={{fontSize:13,fontWeight:'bold',color:'#fff'}}>Add to Cart</Typography>
                      </Box>

                      <Box onClick={this.addItemInWishList.bind(this,this.state.productDetails.product_id)}
                        sx={{
                          height: 35,
                          width: 110,
                          backgroundColor: "#ab266c",
                          display:'flex',
                          justifyContent:'center',
                          alignItems:'center',
                          ml: 2,
                          borderRadius:1,
                        }}
                      >
                        <Typography sx={{fontSize:13,fontWeight:'bold',color:'#fff'}}>Add to Favourt</Typography>
                      </Box>
                    </Box>

                    <Box sx={{height:2,width:'100%',backgroundColor:'#1b7bce',mt:1,mb:1}}></Box>

                    
                  </Box>
                </Grid2>

              </Grid2>
            </Box>


            {
              /// other items list
            }
<br/>

<Box>
<Divider/>


</Box>

          </Container>
        </Box>


        <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                  //transition={Bounce}
                />
      </div>
    );
  }
}

export default ItemDescriptions;

export function ItemDescriptionsc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<ItemDescriptions param={param} navigate={navigate}></ItemDescriptions>)
}


